import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IFilterContractsByLot } from './../../models/filters';
import {
  IContractLot,
  IGenericResult,
  IContractsInLot,
  ILot
} from './../../models/generic';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiLotsDialogService {
  //invoicesReportBaseUrl = `${environment.apis.invoices.baseUrl}/${environment.apis.invoices.microservices.report}`;
  //invoicesReportBaseUrl = `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.invoiceReport}`;
  //baseUrlInvoicesLots = `${environment.apis.invoices.baseUrl}/${environment.apis.invoices.microservices.batch}`;
  baseUrlInvoicesLots = `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.invoiceBatch}`;
  baseurlTranfersLots = `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.transferBatch}`;

  constructor(private _http: HttpClient) { }

  getContractListByBankInvoicing(
    filter: IFilterContractsByLot
  ): Observable<IGenericResult<IContractLot[]>> {
    return this._http.post<IGenericResult<IContractLot[]>>(
      `${this.baseUrlInvoicesLots}/list/contracts/bank`,
      filter
    );
  }

  getDetailsNewLotInvoicing(
    contractsInLots: IContractsInLot
  ): Observable<IGenericResult<ILot>> {
    return this._http.post<IGenericResult<ILot>>(
      `${this.baseUrlInvoicesLots}/details/new-batch`,
      contractsInLots
    );
  }

  generateLotInvoicing(
    contractsInLots: Array<IContractsInLot>
  ): Observable<IGenericResult> {
    return this._http.post<IGenericResult>(
      `${this.baseUrlInvoicesLots}/generate-batchs`,
      contractsInLots
    );
  }

  //generateLotsTransfer(
  //  contractsInLots: Array<IContractsInLot>
  //): Observable<IGenericResult> {
  //  return this._http.post<IGenericResult>(
  //    `${this.baseurlTranfersLots}/generate-batchs`,
  //    contractsInLots
  //  );
  //}

  getDetailsNewLotTransfer(
    contractsInLots: IContractsInLot
  ): Observable<IGenericResult<ILot>> {
    return this._http.post<IGenericResult<ILot>>(
      `${this.baseurlTranfersLots}/details/new-batch`,
      contractsInLots
    );
  }

  getContractListByBankTransfer(
    filter: IFilterContractsByLot
  ): Observable<IGenericResult<IContractLot[]>> {
    return this._http.post<IGenericResult<IContractLot[]>>(
      `${this.baseurlTranfersLots}/list/contracts/bank`,
      filter
    );
  }

  getContractListByPartnerTransfer(
    filter: IFilterContractsByLot
  ): Observable<IGenericResult<IContractLot[]>> {
    return this._http.post<IGenericResult<IContractLot[]>>(
      `${this.baseurlTranfersLots}/list/contracts/partner`,
      filter
    );
  }
}
